<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div v-if="lang==='es'" class="clearfix">
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Nombre de pila"
      name="firstName"
      placeholder="Nombre de pila"
      v-model="firstName"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("firstName") }}</span>

    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Apellido"
      name="lastName"
      placeholder="Apellido"
      v-model="lastName"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("lastName") }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Correo electrónico"
      placeholder="Correo electrónico"
      v-model="email"
      class="w-full mt-6"
      disabled
    />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

    <!--<vs-input
      v-validate="'required|alpha_spaces|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Job Title"
      name="job_title"
      placeholder="Job Title"
      v-model="job_title"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("job_title") }}</span>-->

    <vs-input
      v-validate="'required|alpha_spaces|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="
Empresa"
      name="company"
      placeholder="
Empresa"
      v-model="company"
      class="w-full"
      disabled
    />
    <span class="text-danger text-sm">{{ errors.first("company") }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6'"
      name="password"
      label-placeholder="Contraseña"
      placeholder="Contraseña"
      v-model="password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>

    <!--<vs-input
      type="password"
      v-validate="'min:6|max:10|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>-->

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6"
      >Acepto los términos y condiciones.</vs-checkbox
    >
<!--    <vs-button type="border" to="/user/auth/login" class="mt-6"-->
<!--      >Login</vs-button-->
<!--    >-->
    <vs-button
      class="mt-6"
      @click="registerUserJWt"
      :disabled="!validateForm"
      >
      Registrarse</vs-button
    >
  </div>
  <div v-else class="clearfix">
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="First Name"
      name="firstName"
      placeholder="First Name"
      v-model="firstName"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("firstName") }}</span>

    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Last Name"
      name="lastName"
      placeholder="Last Name"
      v-model="lastName"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("lastName") }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6"
      disabled
    />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

    <!--<vs-input
      v-validate="'required|alpha_spaces|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Job Title"
      name="job_title"
      placeholder="Job Title"
      v-model="job_title"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("job_title") }}</span>-->

    <vs-input
      v-validate="'required|alpha_spaces|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Company"
      name="company"
      placeholder="Company"
      v-model="company"
      class="w-full"
      disabled
    />
    <span class="text-danger text-sm">{{ errors.first("company") }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>

    <!--<vs-input
      type="password"
      v-validate="'min:6|max:10|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>-->

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6"
      >I accept the terms & conditions.</vs-checkbox
    >
<!--    <vs-button type="border" to="/user/auth/login" class="mt-6"-->
<!--      >Login</vs-button-->
<!--    >-->
    <vs-button
      class="mt-6"
      @click="registerUserJWt"
      :disabled="!validateForm"
      >Register</vs-button
    >
  </div>
</template>

<script>

import AddSkill from '../../add-skill/AddSkill.vue'
import i18n from "@/i18n/i18n";
export default {
  data () {
    return {
      usersId: "",
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      job_title: "",
      company: "",
      password: "",
      confirm_password: "",
      isTermsConditionAccepted: true,
      verifyToken: "",
      lang:""
    };
  },
  computed: {
    validateForm () {
      return (
        !this.errors.any() &&
        this.firstName !== "" &&
        this.lastName !== "" &&
        this.email !== "" &&
        this.job_title !== "" &&
        this.company !== "" &&
        this.password !== "" &&
        this.isTermsConditionAccepted === true
      );
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: i18n.t('notification.user.auth.checkLogin.warning.w1'),
          text:  i18n.t('notification.user.auth.checkLogin.warning.w2'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },
    registerUserJWt () {
      // If form is not validated or user is already login return
      if (!this.validateForm /*|| !this.checkLogin()*/) return; // to be done

      console.log("User Verify Token", this.$route.params);

      this.$vs.loading();
      this.lang = this.$route.params.lang;

      this.verifyToken = this.$route.params.userToken;
      this.usersId = this.$route.params.usersId;
      console.log("User Verify Token", this.verifyToken, this.usersId);

      const payload = {
        userDetails: {
          id: this.id,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          job_title: this.job_title,
          company: this.company,
          password: this.password,
          status: "active",
          flag:"userVerified",
          isVerified:1,

        },
        notify: this.$vs.notify
      };

      console.log(payload);
      this.$store
        .dispatch("userAuth/registerUserJWT", payload)
        .then(res => {
          this.$store
            .dispatch("userManagement/fetchUser", this.usersId)
            .then(res => {
              this.id = res.id;
              this.email = res.email;
              // this.username = res.username;
              this.firstName = res.firstName;
              this.lastName = res.lastName;
              window.$cookies.set('firstName',  res.firstName, Infinity);
              // this.company = res.data[0].company; // to be searched from trainee table
              this.job_title = res.jobTitle; // to be searched from trainee table
              console.log("current user id", this.id, res)
            })
            .catch(err => {
              console.log("Error in user registration", err);
            });
          console.log("successful registration", res);
          // router.push({name: 'add-skill'})
          this.$vs.loading.close();
          window.$cookies.set('companyName', this.$route.params.company, Infinity);
          window.$cookies.set('organizationType', this.$route.params.organizationType, Infinity);
          this.$vs.notify({
            title: i18n.t('notification.user.auth.signUp.success.s1'),
            text:  i18n.t('notification.user.auth.signUp.success.s2'),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "primary"
          });


          // Redirect to add your first skill popup
          // this.$router.push('add-your-first-skill');
          if (res.user.userType === "coach"){
            this.$router.push({name: 'user-profile'})
          } else if (res.user.userType === "trainee") {
            this.$router.push({name: 'user-home'})
          } else if (res.user.userType === "admin") {
            this.$router.push({name: 'admin-users-list'})
          }

        })
        .catch(err => {
          console.log("Could not register", err);
        });
    }
  },
  created () {
    this.lang = this.$route.params.lang;

    this.verifyToken = this.$route.params.userToken;
    this.usersId = this.$route.params.usersId;
    console.log("User Verify Token", this.verifyToken, this.usersId);


    this.$store
      .dispatch("userManagement/fetchUser", this.usersId)
      .then(res => {
        this.id = res.id;
        this.email = res.email;
        // this.username = res.username;
        this.firstName = res.firstName;
        this.lastName = res.lastName;
        // this.company = res.data[0].company; // to be searched from trainee table
        this.job_title = res.jobTitle; // to be searched from trainee table
        console.log("current user id", this.id, res)
      })
      .catch(err => {
        console.log("Error in user registration", err);
      });

    this.company = this.$route.params.company;
  }
};
</script>
